// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2bjmL","choiceBoxes":"toolbarselects_choiceBoxes__23-6r","simpleField":"toolbarselects_simpleField__16xV9"};